import { useState, useEffect, useRef } from "react";
import style from "./MarkAsCompletedButton.module.css";
import Icon from "@/ui/icon/Icon";
import { useFinishCourse } from "../../hooks/useFinishCourse";
import { useConfettiWithSound } from "@/hooks/useConfettiWithSound";

function MarkAsCompletedButton({ course }) {
	const [isVisible, setIsVisible] = useState(true);
	const [animate, setAnimate] = useState(false);
	const [clicked, setClicked] = useState(false);
	const buttonRef = useRef(null);

	const { finishCourse } = useFinishCourse({ course });
	const { triggerConfetti, cleanup } = useConfettiWithSound();

	useEffect(() => {
		setAnimate(true);
		return () => {
			cleanup();
		};
	}, [cleanup]);

	const handleClick = async () => {
		if (clicked) return;

		setClicked(true);
		try {
			await Promise.all([finishCourse(), triggerConfetti()]);
			setAnimate(false);
			setIsVisible(false);
		} catch (error) {
			console.error("Error:", error);
			setAnimate(false);
			setIsVisible(false);
		}
	};

	return (
		<>
			{isVisible && (
				<div
					ref={buttonRef}
					className={`${style.buttonHolder} ${
						animate ? style.fadeIn : style.fadeOut
					} ${clicked ? style.disabled : ""}`}
				>
					<div
						className={`${style.button} ${
							clicked ? style.clicked : ""
						}`}
						onClick={handleClick}
					>
						<span>Označi kao pregledano</span>
						<div className={style.icoHolder}>
							<span className={style.defaultIcon}>
								<Icon icon="fa-eye" />
							</span>
							<span className={style.hoverIcon}>
								<Icon icon="fa-check" />
							</span>
						</div>
					</div>
				</div>
			)}
		</>
	);
}

export default MarkAsCompletedButton;
